import { render, staticRenderFns } from "./HeaderArea.vue?vue&type=template&id=99de239a&scoped=true"
import script from "./HeaderArea.vue?vue&type=script&lang=js"
export * from "./HeaderArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de239a",
  null
  
)

export default component.exports